var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferralAnalyticsIcon = function SvgReferralAnalyticsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.14 14.72 3.9-7.8.9.44-3.9 7.8zm11.73.02-3.9-7.8-.9.44 3.9 7.8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18 14a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4 14a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7-21a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
export default SvgReferralAnalyticsIcon;